import { dataZoomIn } from 'dls-icons-data'
import { createIcon } from '../common'

const IconZoomIn = /*#__PURE__*/createIcon(dataZoomIn)
export default IconZoomIn
